import { useAppSelector } from '../../store/hooks'

export function useMqtt() {
  const mqtt = useAppSelector((state) => state.mqtt)
  return mqtt
}
